routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
    $stateProvider
      .state('home', {
        url: '/home',
        template: require('./index.html'),
        controller: 'HomeController',
        controllerAs: 'home',
        authRequired: true,
        data: {pageTitle: 'Home'},
        resolve: {
          secure: (panel) => {

          }
        },
        onEnter: function (secure) {
          console.log('Lola Drive');
          $stateProvider.loaded = false;
        }
      });
}



// WEBPACK FOOTER //
// ./src/app/features/home/routes.js